import { CommentsTrigger } from "frontend/app-header/right-header/comments-action";
import { VideoCallTrigger } from "frontend/app-header/right-header/video-call-action";
import { CommentsPanel } from "frontend/app-header/right-header/views/comments/comments-panel";
import { Box } from "frontend/ui-components/design-system/box/box";
import { Seperator } from "frontend/ui-components/design-system/seperator/seperator";
import { PresentationModeTrigger } from "./presentor-action";
import { TimerVotingMenu } from "./timer-voting-menu";
import { UserActions } from "./views/user-actions/user-actions";
import { UserView } from "./views/user-actions/user-view";
import { AIMenuTrigger } from "./ai-action";
import styles from "./right-header.module.css";
import { useSetAtom } from "jotai";
import { isAIPanelOpenAtom } from "./right-header-atoms";
import { useFeatureFlag } from "frontend/hooks/use-feature-flag/use-feature-flag";
import {
  isExportPdfViewOpenAtom,
  isExportPngViewOpenAtom,
} from "frontend/app-header/left-header/atoms/left-header-atoms";
import { Menu, MenuItem } from "frontend/ui-components/dropdown-menu/dropdown-menu";
import { MenuLabel } from "frontend/ui-components/dropdown-menu/label/label";
import { ExportIcon, ExportAsPNGIcon, ExportAsPDFIcon } from "frontend/app-header/left-header/menu/icons";
import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { useRef } from "react";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

const ExportMenu = () => {
  const setIsExportPdfViewOpen = useSetAtom(isExportPdfViewOpenAtom);
  const setIsExportPngViewOpen = useSetAtom(isExportPngViewOpenAtom);
  const iconRef = useRef<HTMLDivElement>(null);
  const iconHover = useHover(iconRef);

  // note: we set min-width just on the export menu label. that will change the container's
  // width and the width of all other labels.
  // it's very hacky. we should really move to headless ui that enables better styling by caller
  return (
    <Menu
      label={
        <HeaderActionButton className={styles.actionIcon} ref={iconRef}>
          <ExportIcon />
          {iconHover && (
            <Tooltip
              design="monday"
              label={"Export"}
              relativeTo={iconRef}
              side={"bottom"}
              customStyle={{ borderRadius: 3 }}
            />
          )}
        </HeaderActionButton>
      }
      className={styles.menu}
    >
      <MenuItem
        label={<MenuLabel icon={<ExportAsPNGIcon />} label="Save as PNG" />}
        onClick={() => setIsExportPngViewOpen(true)}
      />
      <MenuItem
        label={<MenuLabel icon={<ExportAsPDFIcon />} label="Save as PDF" />}
        onClick={() => setIsExportPdfViewOpen(true)}
      />
    </Menu>
  );
};

export const RightHeader = ({ reps, setFollow }: { reps: any; setFollow: (id: string) => void }) => {
  const setIsAIPanelOpen = useSetAtom(isAIPanelOpenAtom);

  const isAIFeatureEnabled = useFeatureFlag("ai-features");

  const handleRightHeaderClick = (event: React.MouseEvent) => {
    // Check if the clicked element is part of AIMenuTrigger
    const aiTrigger = (event.currentTarget as HTMLElement).querySelector("[data-ai-trigger]");
    const clickedElement = event.target as HTMLElement;

    // If clicked element is not the AI trigger or its children, close AI panel
    if (aiTrigger && !aiTrigger.contains(clickedElement)) {
      setIsAIPanelOpen(false);
    }
  };

  return (
    <>
      <div onClick={handleRightHeaderClick}>
        <Box p="5px 9px 5px 5px" direction="row" className={styles.rightHeader}>
          {isAIFeatureEnabled && <AIMenuTrigger />}
          <ExportMenu />
          <PresentationModeTrigger />
          <TimerVotingMenu />
          <VideoCallTrigger />
          <CommentsTrigger />
          <Seperator direction="vertical" />
          <UserActions reps={reps} />
        </Box>
      </div>
      <CommentsPanel />
      <UserView reps={reps} setFollow={setFollow} />
    </>
  );
};
